import DefaultValidation from '@/services/validations/DefaultValidation';

export default class UnidadeMedidaAreaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        if (!model.descricao) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (!model.sigla) {
            refs.siglaInput.focusedOut = true;
            validated = false;
        }

        if (!model.valorEmMetrosQuadrados) {
            refs.valorEmMetrosQuadradosInput.focusedOut = true;
            validated = false;
        } else if (parseFloat(model.valorEmMetrosQuadrados) <= 0) {
            refs.valorEmMetrosQuadradosInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}